module.exports = __webpack_public_path__ + "static/media/shower.0a814a4d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/weather/images/shower.gif
// module id = 485
// module chunks = 0